import { debounce, clearUser } from 'common/js/util';

function logout() {
  clearUser();
  window.location.href = '/login';
}

document.addEventListener('mousemove', debounce(logout, 10 * 60 * 1000), false);
